import { render } from "./Listsnovip.vue?vue&type=template&id=b93bf586&scoped=true"
import script from "./Listsnovip.vue?vue&type=script&lang=js"
export * from "./Listsnovip.vue?vue&type=script&lang=js"

import "./Listsnovip.vue?vue&type=style&index=0&id=b93bf586&scoped=scoped&lang=css"

import exportComponent from "D:\\CODE\\clpgaAppDevnew\\clpga_html\\f_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b93bf586"]])

export default __exports__